import React from "react";
import Caption from "./styled/caption";
import Credit from "./styled/credit";
import styled, { css } from "styled-components"
import StyledCaption from "./styled/caption"
import { StyledArtifact } from "./artifact"


const Figure =({ 
  children, 
  caption = undefined, 
  captionAlign = undefined,
  captionSize = undefined,
  maxWidth = undefined, 
  maxWidthMobile = undefined,
  width = undefined,
  credit = undefined, 
  floatTo = undefined, 
  fitToMargin = undefined, 
  date, 
  marginTop = undefined
}) => {
  
  return (
    <StyledFigure 
      maxWidth={maxWidth} 
      maxWidthMobile={maxWidthMobile} 
      floatTo={floatTo}
      fitToMargin={fitToMargin}
      marginTop={marginTop}
      captionAlign={captionAlign}
      width={width}
    >
      <div>
        {children}
        {credit && (
          <Credit>{credit}</Credit>
        )}
      </div>
      {caption && (
        <Caption textAlign={captionAlign} textSize={captionSize}>{caption}</Caption>
      )}
      {date && (
        <time>{date}</time>
      )}
    </StyledFigure>
  )
}
export default Figure;


const StyledFigure = styled.figure`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  margin: calc(1.5 * var(--text-size)) auto;
  @media ( min-width: 48em ) {
    margin: calc(3 * var(--text-size)) auto;
  }
  > div {
    position: relative;
    max-height: none;
    width: ${props=> props.width ? props.width : '100%'};
    max-width: ${props=> props.maxWidth ? props.maxWidth : 'var(--figure-max-width)'};
    margin: 0 auto 1.5em;
    &:last-child {
      margin-bottom: 0;
    }
    @media ( max-width: 40em ) {
      max-width: var(--text-max-width);
      max-width: ${props=> props.maxWidthMobile ? props.maxWidthMobile : 'var(--figure-max-width)'}
    }
  }
  time {
    font-family: var(--font-caption);
    font-weight: var(--font-caption-weight);
    margin-top: 0.5em;
    color: var(--theme-text-against-dark-medium);
  }
  ${props => props.captionAlign && css`
    ${StyledCaption} {
      margin-right: 0;
      margin-left: 0;
      width: 100%;
      max-width: 100%;
    }
  `}

  ${StyledArtifact} & {
    margin-top: 0;
    margin-bottom: 0;
    > div {
      margin-bottom: 0.6875em;
    }
  }
`

export { StyledFigure };